export enum ServerConstants {
    SUCCESS = 200,
    BAD_REQUEST = 400,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500
}

export enum ServerErrorMessage {
    INVALID_SESSION_TOKEN = 'Invalid session token'
}